import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { UnreadNotifications } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const useUnreadNotificationQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<UnreadNotifications>({
    queryKey: ["unread", branchId],
    queryFn: () =>
      get2(
        `internal/secure/pos/v1/internal/notifications/unread/counts/${branchId}`
      ),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    enabled: branchId > 0,
  });

  const totalUnreadNotification = useMemo(
    () => Object.values(query?.data || {}).reduce((acc, cur) => acc + cur, 0),
    [query?.data]
  );

  return { ...query, totalUnreadNotification };
};

export default useUnreadNotificationQuery;
